import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { NearbyHelp } from "@/components/NearbyHelp";
import { ReviewOffers } from "@/components/ReviewOffers";
import { MyImpactRow } from "./StatCard";
import { UpNextCard } from "./UpNextCard";
import { ForYouSection } from "./ForYouSection";
import { ReferralsPanel } from "./ReferralsPanel";
import { MyActivityTabs } from "./MyActivityTabs";
import { MyCommunityCard } from "./MyCommunityCard";
import { NudgeStrip } from "./NudgeStrip";
import { StoryNudgeCard } from "./StoryNudgeCard";
import { VolunteerStarterChecklist } from "./VolunteerStarterChecklist";

/**
 * Item 4 (2026-07): volunteer dashboard, restructured top-to-bottom —
 *   1. header (in Dashboard.jsx: welcome + tier + actions)
 *   2. nudge strip (streak / invite / feedback chips — top so the daily
 *      streak is immediately visible; external review, 2026-07)
 *   3. Up next (next 2 events + alerts footer)
 *   4. Find your next cause (swipe CTA + top-3 recommendations)
 *   5. My community  6. My impact row  7. My activity (tabbed, paginated)
 * First visit (no applications AND no hour logs): modules 5-7 are replaced
 * by the getting-started checklist. Actionable strips (story nudge, offers
 * on your help requests, neighbours nearby) only render when there is
 * something to act on.
 */
export function VolunteerHome({
  user, stats, hours, apps, matched, recs, inspiration,
  hosted, hostPending, alertRadius, saveAlerts,
  applyToOpp, withdrawApp, approveHost, rejectHost,
}) {
  const [checklist, setChecklist] = useState(null);
  const [checklistDismissed, setChecklistDismissed] = useState(
    () => localStorage.getItem(`vol_checklist_dismissed_${user.user_id}`) === "1"
  );
  useEffect(() => {
    api.starterChecklist().then(setChecklist).catch(() => setChecklist({ show: false }));
  }, []);

  // firstVisit uses the raw hours history (ALL statuses) — stats.logs_count
  // only counts APPROVED logs, which hid the activity tabs (and their pending
  // Hours history) from volunteers whose logs were still awaiting approval.
  const firstVisit = hours.length === 0 && apps.length === 0;
  const showChecklist = firstVisit && !checklistDismissed && !!checklist?.show;

  return (
    <>
      <NudgeStrip />
      <StoryNudgeCard />
      <ReviewOffers />
      <NearbyHelp />
      <UpNextCard apps={apps} hosted={hosted} user={user} alertRadius={alertRadius} saveAlerts={saveAlerts} />
      <ForYouSection recs={recs} inspiration={inspiration} matched={matched} applyToOpp={applyToOpp} />
      {user?.is_referrer && <ReferralsPanel />}
      {firstVisit && checklist === null ? null : showChecklist ? (
        <VolunteerStarterChecklist user={user} data={checklist} onDismiss={() => setChecklistDismissed(true)} />
      ) : (
        <>
          <MyCommunityCard hosted={hosted} />
          <MyImpactRow stats={stats} />
          <MyActivityTabs
            hours={hours} apps={apps} hostPending={hostPending} hosted={hosted}
            withdrawApp={withdrawApp} approveHost={approveHost} rejectHost={rejectHost}
          />
        </>
      )}
    </>
  );
}
